import styles from './status.less';

export {styles};

interface StatusProps {
    loading: boolean;
}

export default class Status extends React.PureComponent<StatusProps, null> {

    render() {
        return (
            <div className={styles.status}>
                <div className={styles.body}>
                    {this.props.loading && (
                        <>
                            <div className={classNames('border-spinner', styles.spinner)}/>
                            <div className={styles.title}>{_('Please, wait')}</div>
                            <div className={styles.description}>&nbsp;</div>
                        </>
                    )}

                    {!this.props.loading && (
                        <>
                            <i className="fa fa-check"/>
                            <div className={classNames(styles.title, styles.colorGreen)}>{_('[REVIEW_MODAL] Thank you for your review')}</div>
                            <div className={styles.description}>{_('[REVIEW_MODAL] We will publish the review once we have verified that it meets our terms')}.</div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}
